import * as React from 'react';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import '../css/hero-carousel.sass';
import CampfireCarousel from './CampfireCarousel';

interface HeroCarouselProps {
  name: string;
  tagLine: string;
  autoPlaySpeed?: string;
  children: ReactElement[];
  id?: string;
  dragThreshold?: string;
}

export default function HeroCarousel(props: HeroCarouselProps) {
  const [bgImgState, setBgImgState] = useState<string>('');
  const [loadedState, setLoadedState] = useState(
    document.readyState === 'complete'
  );

  const filteredChildren: ReactNode[] =
    props.children?.filter(
      // @ts-ignore
      (el: ReactNode) => !el?.type?.toString().includes('fragment')
    ) || [];

  useEffect(() => {
    if (filteredChildren && filteredChildren.length > 0) {
      // @ts-ignore
      setBgImgState(filteredChildren[0]?.props?.bgImage);
    }
    document.onreadystatechange = () => {
      setLoadedState(document.readyState === 'complete');
    };
  }, []);

  let keyIndex = 0;

  return (
    <div id={props.id} className="hero-carousel-container">
      {loadedState && (
        <div className="hero-banner">
          <img className="bg-img" alt="" src={bgImgState} />
          <div className="pkg-info">
            <strong>{props.name}</strong>
            <p>{props.tagLine}</p>
          </div>
          <div className="credit">
            <div className="hero-carousel">
              <CampfireCarousel
                id="hero-carousel"
                onChange={(index: number) => {
                  // @ts-ignore
                  setBgImgState(filteredChildren[index]?.props?.bgImage);
                }}
                autoPlaySpeed={props.autoPlaySpeed}
                dragThreshold={props.dragThreshold}
              >
                {props.children?.map((child) => {
                  keyIndex += 1;
                  return React.cloneElement(child, {
                    expandable: false,
                    onChange: () => {},
                    key: `hero-carousel-child-${keyIndex}`,
                  });
                })}
              </CampfireCarousel>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
